import Vue from 'vue'
import VueI18n from 'vue-i18n'
// 引入elementui 的中英文翻译
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

Vue.use(VueI18n)

let DEFAULT_LANG = localStorage.getItem('lang') || navigator.language || navigator.userLanguage
console.log(DEFAULT_LANG)
DEFAULT_LANG = DEFAULT_LANG.includes('zh') ? 'zh-CN' : 'en-US'
const locales = {
  'zh-CN': Object.assign(window.langZh, zhLocale), // 合并文件用来处理ui组件的中英文
  'en-US': Object.assign(window.langEn, enLocale)
}

const i18n = new VueI18n({
  locale: DEFAULT_LANG,
  messages: locales,
  silentTranslationWarn: true
})

window.i18n = i18n
export default i18n
